<template>
  <table width="98%" border="0" cellpadding="0" cellspacing="8">
    <tr>

      <td width="100%" align="right">
        <table width="72" height="18" border="0" cellpadding="1" cellspacing="1" bgcolor="#305F8D">
          <tr align="right">
            <td bgcolor="#F1F5FA" valign="middle" align="right">
              <div align="center">
                <router-link :to="linkTo">{{$t('insert')}}</router-link>
              </div>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</template>
<script>
export default {
  props: {
    linkTo: {
      require: true,
      default:{

      }
    },
  }
};
</script>